export const HomeIcon = ({
  fill = '#fff',
  stroke = '#fff',
  width = '100%',
  height = '100%',
  viewBox = '0 0 24 24',
}) => (
  <svg width={height} height={width} viewBox={viewBox} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path
      // eslint-disable-next-line max-len
      d="M2.36407 12.9579C1.98463 10.3208 1.79491 9.00229 2.33537 7.87495C2.87583 6.7476 4.02619 6.06234 6.32691 4.69181L7.71175 3.86687C9.80104 2.62229 10.8457 2 12 2C13.1543 2 14.199 2.62229 16.2882 3.86687L17.6731 4.69181C19.9738 6.06234 21.1242 6.7476 21.6646 7.87495C22.2051 9.00229 22.0154 10.3208 21.6359 12.9579L21.3572 14.8952C20.8697 18.2827 20.626 19.9764 19.451 20.9882C18.2759 22 16.5526 22 13.1061 22H10.8939C7.44737 22 5.72409 22 4.54903 20.9882C3.37396 19.9764 3.13025 18.2827 2.64284 14.8952L2.36407 12.9579Z"
      stroke={stroke}
      strokeWidth="1.5"
    />
    <path d="M12 15V18" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
)
